import React from 'react';
import ValidationElement from '../ValidationElement';
import Dropdown from '../Dropdown';

export default class ApoFpo extends ValidationElement {
  constructor(props) {
    super(props);
    this.handleError = this.handleError.bind(this);
  }

  handleError(value, arr) {
    const resultArr = arr.map((err) => ({
      code: `apofpo.${err.code}`,
      valid: err.valid,
      uid: err.uid,
    }));

    return this.props.onError(value, resultArr);
  }

  render() {
    return (
      <Dropdown
        attribute={this.props.attribute}
        name={this.props.name}
        label={this.props.label}
        placeholder={this.props.placeholder}
        className={this.props.className}
        disabled={this.props.disabled}
        onUpdate={this.props.onUpdate}
        onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
        onBlur={this.props.onBlur}
        onFocus={this.props.onFocus}
        value={this.props.value}
        required={this.props.required}
        tabBack={this.props.tabBack}
        tabNext={this.props.tabNext}
      >
        <option key="AA" value="AA">
          AA
        </option>
        <option key="AE" value="AE">
          AE
        </option>
        <option key="AP" value="AP">
          AP
        </option>
      </Dropdown>
    );
  }
}

ApoFpo.defaultProps = {
  tabBack: () => { },
  tabNext: () => { },
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
  required: false,
};

ApoFpo.errors = [];
